export const CHAT_BOX_WIDTH = 805;
export const BUTTON_CHAT_SIZE = 40;
